import React from "react";
import { MdClear } from "react-icons/md";
import useGetLanguage from "../../../../utils/useGetLanguage";
import { LanguageText } from "../../../../dictionary/GroupsText";

interface SiteNameProps {
  name: string;
  onChange: (name: string) => void;
  onClear: () => void;
}

const SiteName: React.FC<SiteNameProps> = ({ name, onChange, onClear }) => {
  const language: LanguageText = useGetLanguage({
    fileName: "GroupsText",
  });
  return (
    <div className="flex flex-col w-full max-w-full min-w-0 bg-white rounded-md sm:rounded-lg p-2 sm:p-3 md:p-4">
      <label className="block text-xs sm:text-sm font-medium mb-1 sm:mb-1.5">
        {language?.groupStyle?.components?.siteName?.title || "Site Name"}
      </label>
      <div className="relative w-full min-w-0">
        <input
          type="text"
          className="border border-gray-300 rounded-md w-full max-w-full min-w-0 px-2 sm:px-3 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base pr-7 sm:pr-8 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
          value={name}
          onChange={(e) => onChange(e.target.value)}
          placeholder="rpr-IoT"
        />
        {name && (
          <button
            type="button"
            className="absolute right-1.5 sm:right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-red-500 transition-colors p-0.5 sm:p-1"
            onClick={onClear}
            aria-label="Clear site name"
          >
            <MdClear size={14} className="sm:w-4 sm:h-4 md:w-5 md:h-5" />
          </button>
        )}
      </div>
    </div>
  );
};
export default SiteName;
